import { useEffect, useState } from 'react';
import { getJson } from '../../store/fetch';
/**
 * A hook implementation of fetch
 * @param url The url of the endpoint to be called
 * @param changeOn An array containing values that retrigger the fetch when changed
 * @returns An array containing 3 items, the first is the response (result.json.items), the second is the status, the third is a function to set the items
 */
export function useFetchItems<Response>(
    url: string,
    changeOn: Readonly<any[]> = []
): [Response[], FetchStatus, (items: Response[]) => void] {
    const [status, setStatus] = useState<FetchStatus>('Init');
    const [items, setItems] = useState<Response[]>([]);

    async function fetch() {
        setStatus('Loading');
        const result = await getJson(url);
        if (result.json.items) {
            setItems(result.json.items);
        } else {
            setItems([]);
        }
        setStatus('Done');
    }

    useEffect(() => {
        fetch();
    }, [url, ...changeOn]);

    return [items, status, setItems];
}

export type FetchStatus = 'Init' | 'Loading' | 'Done';
